function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.257 18.88c3.752-3.958 3.641-10.192-.25-14.014-3.89-3.821-10.125-3.821-14.015 0-3.89 3.822-4.001 10.056-.25 14.014 1.889 1.987 4.51 3.112 7.25 3.112 2.742 0 5.363-1.125 7.25-3.112 0 0 .015.007.015 0zM12 3.237c3.375-.006 6.469 1.847 8.012 4.799 1.543 2.952 1.276 6.505-.693 9.201-.95-1.805-2.554-3.194-4.495-3.89 1.486-1.176 2.056-3.145 1.423-4.914-.634-1.77-2.333-2.953-4.24-2.953s-3.606 1.184-4.24 2.953c-.633 1.769-.063 3.738 1.423 4.914-1.941.696-3.545 2.085-4.495 3.89C2.728 14.543 2.46 10.993 4 8.042c1.54-2.95 4.628-4.806 8-4.805zM8.7 9.75c0-1.85 1.5-3.35 3.35-3.35s3.35 1.5 3.35 3.35-1.5 3.35-3.35 3.35S8.7 11.6 8.7 9.75zm-3.1 8.505c1.08-2.644 3.648-4.372 6.5-4.372s5.42 1.728 6.5 4.372c-3.627 3.505-9.373 3.505-13 0z",
  transform: "translate(-120 -299) translate(120 299)"
}))));

var SvgIconAccount = function SvgIconAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-account.2c8dff11.svg";
export { ForwardRef as ReactComponent };